import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PollContentObjectDetailDataObject } from 'models/service';
import type { PollSubmitData } from '../form/PollForm';

export const updatePoll = async (poll: PollSubmitData) =>
  apiClient.put<PollContentObjectDetailDataObject, ApiClientResponse<PollContentObjectDetailDataObject>>(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- updatePoll is only called for existing polls, which always have an id
    routes.polls.update(poll.id!),
    { poll },
  );
